module.exports = __webpack_public_path__ + "images/ai_recommendations/building-4d6d330661acb972d5df25ae19a88360.svg";